import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Color from 'color';
import { replaceValueInEvent } from '@dnhb/node_package';

const ContainerLabel = styled('label')`
  display: block;
  width: 48px;
  cursor: pointer;
  flex-shrink: 0;
  @media ${(props)=> props.theme.mobile} {
    width: 64px;
  }
`;

const Input = styled('input')`
  position: absolute;
  opacity: 0;

  &:focus + div::before {
    box-shadow: 0 0 0 6px
      ${({ checked, theme }) =>
        Color(checked ? theme.primaryColor : theme.borderColor)
          .alpha(0.25)
          .string()};
  }

  &:hover + div::before {
    box-shadow: 0 0 0 10px
      ${({ checked, theme }) =>
        Color(checked ? theme.primaryColor : theme.borderColor)
          .alpha(0.25)
          .string()};
  }
`;

const Slider = styled('div')`
  position: relative;
  height: 24px;
  width: 100%;
  background-color: ${({ checked, theme }) => (checked ? theme.primaryColor : theme.disabledBackgroundColor)};
  border-radius: 12px;

  &::before {
    content: '';
    position: absolute;
    top: 2px;
    left: ${({ checked }) => (checked ? '25px' : '3px')};
    height: 20px;
    width: 20px;
    background-color: ${props => props.theme.backgroundColor};
    border-radius: 50%;
    transition: left 200ms;
  }
  
  @media ${(props)=> props.theme.mobile} {
    height: 32px;
    border-radius: 16px;
    
    &::before {
      left: ${({ checked }) => (checked ? 'calc(64px - 28px - 3px)' : '3px')};
      height: 28px;
      width: 28px;
    }
  }
`;

const ToggleSwitch = ({ value, onChange, ...props }) => (
  <ContainerLabel>
    <Input
      {...props}
      checked={value}
      type="checkbox"
      onChange={e => onChange(replaceValueInEvent(e, e.target.checked))}
    />
    <Slider checked={value} />
  </ContainerLabel>
);

ToggleSwitch.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

ToggleSwitch.defaultProps = {
  value: false,
  onChange: () => {},
};

export default ToggleSwitch;
